import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, ViewContainerRef, SimpleChanges, OnChanges, AfterViewChecked, AfterViewInit, AfterContentInit, SecurityContext, NgZone, Renderer2, Output, EventEmitter } from '@angular/core';
// import { SessionProvider } from 'ess-plugin-base';
import { SessionProvider, I18N } from 'ess-plugin-base';
// import { Router, ActivatedRoute } from '@angular/router';
// import { Subscription, Observable, of } from 'rxjs';
// import { MatSnackBar } from '@angular/material/snack-bar';
// import { Constants } from '../Constants';
// import { MailProvider } from '../../providers/mail.provider';

import { MatChipInputEvent, MatAutocompleteSelectedEvent, MatSelectChange } from '@angular/material';
import { FormControl } from '@angular/forms';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';

// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { CacheProvider } from '../../providers/cache.provider';
// import { PlatformProvider } from '../../providers/platform.provider';
// import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TimeEvent, TimeProvider } from '../time.provider';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
// import { Month } from '../calendar/month.calendar';
import { SearchProvider, MatchType } from '../../search.provider';

@Component({
  selector: 'event-selector',
  templateUrl: './event.selector.html',
  styleUrls: ['./event.selector.scss']
})
export class EventSelector implements OnInit, OnChanges, OnDestroy {

    allyears = [
        2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009,
        2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019,
        2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029,
        2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039,
        2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049,
        2050, 2051, 2052, 2053, 2054, 2055, 2056, 2057, 2058, 2059,
    ];

    allmonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  year: number;
  month: number;

  planned: boolean;
  allday: boolean;

  startTime: string;
  endTime: string;

  tags: any = {};
  resources: any = {};

  phrase: string;

  @Input('viewDate')
  viewDate: Date;

  @Input('tagsets')
  tagsets: any;

  @Output('onFilter')
  onFilter: EventEmitter<any> = new EventEmitter<any>();

  tagsCtl = new FormControl();

  resourcesCtl = new FormControl();

  isLoading: boolean;

  filteredRes: any[] = [];   //Observable<any[]>;

   @ViewChild('resInput', {static: true}) 
   resInput: ElementRef;

   selectable = true;
   removable = true;
   addOnBlur = true;
   readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    related: any[] = [];

  constructor(protected session: SessionProvider, public i18n: I18N, 
          // private sanitizer: DomSanitizer, private renderer: Renderer2, private zone: NgZone,
              // private router: Router, private activatedRoute: ActivatedRoute, 
              // private _snackBar: MatSnackBar, // private platform: PlatformProvider, 
              private provider: TimeProvider, private search: SearchProvider) { //}, private cacheProvider:CacheProvider) {

      this.resourcesCtl.valueChanges
      .pipe(
          debounceTime(300),
          tap(() => { /*console.log('started');*/ this.isLoading = null;} ),
          switchMap((name: string) => this.search.getResources(name, 10, MatchType.PARTIAL, null)
          .pipe(
              finalize(() => this.isLoading = false),
              )
          )
      )
      .subscribe((result : any) => { 
          // console.log(result); 
          this.filteredRes = result.resources; 
      });
  }


  ngOnInit() {
      this.viewDate = new Date();

      this.year = this.viewDate.getFullYear();
      this.month = this.viewDate.getMonth();

    if (!this.tagsets) {
        this.provider.getTagsets()
        .then(data => {
            this.tagsets = data;
        })
    }             
  }

  ngOnDestroy() {
  }

  ngOnChanges(changes: SimpleChanges) {
  
    if (changes.viewDate) {
        this.year = this.viewDate.getFullYear();
        this.month = this.viewDate.getMonth();
    }
  }

  /*startTimeChanged(time: string) {
      if (!this.event.starts) {
        this.event.starts = new Date();
      }
      let all = time.split(' ');
      let parts = all[0].split(':');
      
      let noon = (all[1].toLowerCase() == 'pm')? 12 : 0;
      let hrs = +noon + +parts[0];
      let mins = +parts[1];

      this.event.starts.setHours(hrs);
      this.event.starts.setMinutes(mins);
  }

  endTimeChanged(time: string) {
    if (!this.event.ends) {
      this.event.ends = new Date();
    }
    let all = time.split(' ');
    let parts = all[0].split(':');
    
    let noon = (all[1].toLowerCase() == 'pm')? 12 : 0;
    let hrs = +noon + +parts[0];
    let mins = +parts[1];

    this.event.ends.setHours(hrs);
    this.event.ends.setMinutes(mins);
}*/

tagsChanged(tagset: any, e: MatSelectChange) {
    // console.log("Selection for", tagset, e);
    // console.log("Selected", e.value);
    
/*    if (Array.isArray(e.value)) {
      let multi: String[] = [];
      e.value.map((tag) => multi.push(tag.code));
      this.event.tags[tagset.code] = multi;
    } else {
      this.event.tags[tagset.code] = e.value.code;
    }
    */
}

restart(event: MatChipInputEvent): void {
    
  const input = event.input;

  // Reset the input value
  if (input) {
    input.value = '';
  }
  
}

/*relate(event: MatChipInputEvent): void {
    
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.related.push(value);
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
    
  }*/

  unrelate(array: any[], res: any): void {
    const index = array.indexOf(res);

    if (index >= 0) {
      array.splice(index, 1);
      return;
    }

    for(let i=0; i<array.length; i++) {
      if (array[i].guid == res.guid) {
        array.splice(i, 1);
        break;
      }
    }
  }

  selectedRes(event: MatAutocompleteSelectedEvent): void {
    // console.log(event);
    if (event && event.option) {
        let res = event.option.value;
        if (!this.related.includes(res)) {
          
          this.related.push(res);   //event.option.value);   // viewValue
        }
      }

    // this.toUserInput.nativeElement.value = '';
    this.resourcesCtl.setValue(null);
  }  

  doFilter () {
    let resStr = '';
        if (this.related) {
          resStr = this.related[0].resource;    //this.resources = {res: this.related}
        }

        this.onFilter.emit({
            year: this.year,
            month: this.month,
            startTime: this.startTime,
            endTime: this.endTime,
            tags: this.tags,
            res: resStr
        })
  }

}
